import React from 'react'
import {Navigate, Route, Routes, Outlet} from 'react-router-dom'
import {MasterLayout} from '../../_theme/layout/MasterLayout'
import {
  // Overview,
  Companies,
  CompanyDetails,
  CreateCompany,
  Financiers,
  CreateFinancier,
  FinancierDetails,
  CreateServiceProvider,
  ServiceProviderDetails,
  ServiceProviders,
  Opportunities,
  DiscoverOpportunities,
  CallDetails,
  GrantDetails,
  CreateGrantOpportunity,
  Settings,
  CreateUser,
  CreateGrantProviders,
  GrantProviderDetails,
  GrantProviders,
  ErrorsPage,
  LazyComponent,
  InboxPage,
  ThreadDetailPage,
} from './LazyRoutes'
import {CorrespondenceHostProvider} from '../features/correspondence/host/CorrespondenceHostContext'
import {internalHost} from '../features/correspondence/host/internalHost'

const PrivateRoutes: React.FC = () => {
  return (
    <Routes>
      <Route element={<MasterLayout />}>
        <Route path='auth/*' element={<Navigate to='/companies?page=1&pageSize=6' />} />
        {/* <Route path="/overview" element={<LazyComponent><Overview /></LazyComponent>} /> */}
        <Route index element={<Navigate to='/companies' />} />
        <Route
          path='/error'
          element={
            <LazyComponent>
              <ErrorsPage />
            </LazyComponent>
          }
        />
        <Route path='companies' element={<Outlet />}>
          <Route
            index
            element={
              <LazyComponent>
                <Companies />
              </LazyComponent>
            }
          />
          <Route
            path='add'
            element={
              <LazyComponent>
                <CreateCompany />
              </LazyComponent>
            }
          />
          <Route
            path=':id'
            element={
              <LazyComponent>
                <CompanyDetails />
              </LazyComponent>
            }
          />
          <Route path='*' element={<Navigate to='/error/404' />} />
        </Route>
        {/* Other routes */}
        <Route
          path='/financiers'
          element={
            <LazyComponent>
              <Financiers />
            </LazyComponent>
          }
        />
        <Route
          path='/financiers/add'
          element={
            <LazyComponent>
              <CreateFinancier />
            </LazyComponent>
          }
        />
        <Route
          path='/financiers/:id'
          element={
            <LazyComponent>
              <FinancierDetails />
            </LazyComponent>
          }
        />
        <Route
          path='/development/partners'
          element={
            <LazyComponent>
              <GrantProviders />
            </LazyComponent>
          }
        />
        <Route
          path='/development/partners/add'
          element={
            <LazyComponent>
              <CreateGrantProviders />
            </LazyComponent>
          }
        />
        <Route
          path='/development/partners/:id'
          element={
            <LazyComponent>
              <GrantProviderDetails />
            </LazyComponent>
          }
        />
        <Route
          path='/analyst/calls'
          element={
            <LazyComponent>
              <Opportunities />
            </LazyComponent>
          }
        />
        <Route
          path='/analyst/discover-opportunities'
          element={
            <LazyComponent>
              <DiscoverOpportunities />
            </LazyComponent>
          }
        />
        <Route
          path='/analyst/call-details'
          element={
            <LazyComponent>
              <CallDetails />
            </LazyComponent>
          }
        />
        <Route
          path='/analyst/grant-details'
          element={
            <LazyComponent>
              <GrantDetails />
            </LazyComponent>
          }
        />
        <Route
          path='/analyst/create-opportunity'
          element={
            <LazyComponent>
              <CreateGrantOpportunity />
            </LazyComponent>
          }
        />
        <Route
          path='/services/providers'
          element={
            <LazyComponent>
              <ServiceProviders />
            </LazyComponent>
          }
        />
        <Route
          path='/services/providers/add'
          element={
            <LazyComponent>
              <CreateServiceProvider />
            </LazyComponent>
          }
        />
        <Route
          path='/services/providers/:id'
          element={
            <LazyComponent>
              <ServiceProviderDetails />
            </LazyComponent>
          }
        />
        <Route
          path='/settings'
          element={
            <LazyComponent>
              <Settings />
            </LazyComponent>
          }
        />
        <Route
          path='/settings/*'
          element={
            <LazyComponent>
              <Settings />
            </LazyComponent>
          }
        >
          <Route
            path='add'
            element={
              <LazyComponent>
                <CreateUser />
              </LazyComponent>
            }
          />
        </Route>
        {/* <Route path='/' element={<Navigate to='/companies' />} /> */}
        {/* Correspondence */}
        <Route
          path='/correspondence'
          element={
            <CorrespondenceHostProvider host={internalHost}>
              <LazyComponent>
                <InboxPage />
              </LazyComponent>
            </CorrespondenceHostProvider>
          }
        />
        <Route
          path='/correspondence/:threadId'
          element={
            <CorrespondenceHostProvider host={internalHost}>
              <LazyComponent>
                <ThreadDetailPage />
              </LazyComponent>
            </CorrespondenceHostProvider>
          }
        />
        {/* Catch-all for invalid routes */}

        <Route path='*' element={<Navigate to='/error/404' />} />
      </Route>
      <Route
        path='/error/:errorCode'
        element={
          <LazyComponent>
            <ErrorsPage />
          </LazyComponent>
        }
      />
    </Routes>
  )
}

export {PrivateRoutes}
